import styled from "styled-components";
import { OverHeroContainer } from "App/styles";
import { colors, breakpoints } from "definitions";

export const Container = styled(OverHeroContainer)`
  background-color: ${colors.background.white};
  align-items: center;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  flex-direction: column;
  width: 95%;
  padding: 2.4rem;

  .field-input-group {
    width: 100%;
  }
`;

export const Main = styled.div`
  display: flex;

  width: 100%;
  border-radius: 6px 6px 0px 0px;

  margin-bottom: 2rem;

  /* Hay entidades cuyo toolbar no trae filtros: sin esto el hueco del filtro
     quedaba igual, arriba de la fila de orden. */
  &:empty {
    margin-bottom: 0;
  }

  label {
    padding-top: 0px;
    margin: 0;
  }
`;
export const Footer = styled.div`
  display: flex;

  width: 100%;
  border-radius: 0px 0px 6px 6px;

  align-items: flex-end;
  justify-content: space-between;

  .field-input-group {
    width: 25%;
  }

  ${breakpoints.tablet} {
    flex-direction: column;
  }

  ${breakpoints.phablet} {
    .field-input-group {
      width: 50%;
    }
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 2.4rem;

  /* Los filtros se reparten el ancho de la tarjeta: si hay uno solo (el caso
     de casi todas las entidades) ocupa todo, y si hay dos van mitad y mitad.
     Antes iban fijos al 45%, así que un filtro solo dejaba media tarjeta
     vacía. El flex-basis en 0 gana sobre el width: 100% que el Container le
     pone a los campos, sin importar el orden de las reglas. */
  .field-input-group {
    flex: 1 1 0;
    min-width: 0;
  }

  ${breakpoints.phablet} {
    flex-direction: column;
    gap: 1.6rem;
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;

  ${breakpoints.tablet} {
    margin-top: 2rem;
  }
`;

// Separación explícita entre el select de orden y el checkbox: sin el gap el
// checkbox quedaba pegado al borde derecho del select.
export const ContainerField = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-end;
  gap: 3rem;

  .checkbox-field {
    margin: 0;
    margin-bottom: 0.5rem;
  }

  ${breakpoints.tablet} {
    justify-content: space-between;

    .checkbox-field {
      flex-basis: 70%;
    }
  }

  ${breakpoints.mobile} {
    flex-direction: column;
    align-items: flex-start;

    .checkbox-field {
      margin-top: 2rem;
      margin-left: 0;
    }
  }
`;
